var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-3"},[_c('extra-equipment-column',{attrs:{"groups":_vm.filtered(_vm.leftEquipmentGroups)}}),_vm._v(" "),_c('extra-equipment-column',{attrs:{"groups":_vm.filtered(_vm.rightEquipmentGroups)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }